// Generated by Melange

import * as Buhta_documentapis__Buhta_document_v1_sign_method from "./buhta_document_v1_sign_method.js";
import * as Buhta_documentapis__Buhta_document_v1_signer_entity_type from "./buhta_document_v1_signer_entity_type.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  330,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Metadata"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    {
                                      TAG: /* Module */ 0,
                                      _0: [
                                        [
                                          /* Function */ 0,
                                          "make"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_proto"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_proto"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_json"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_json"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "name"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "merge"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_proto$p"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_proto_exn"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_json_exn"
                                        ]
                                      ]
                                    },
                                    "$$File"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "FileDocument"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ParticipantInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSignIntent"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "FileDocument"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSign"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ErrorInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSignResult"
                      ]
                    ]
                  },
                  "V1alpha1"
                ]]
            },
            "Sign"
          ]]
      },
      "Edo"
    ]]
});

const Edo = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  623,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Metadata"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "$$File"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "FileDocument"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ParticipantInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSignIntent"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "FileDocument"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSign"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ErrorInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSignResult"
                ]
              ]
            },
            "V1alpha1"
          ]]
      },
      "Sign"
    ]]
});

const Sign = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  914,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Metadata"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "$$File"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FileDocument"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ParticipantInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSignIntent"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FileDocument"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSign"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ErrorInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSignResult"
          ]
        ]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1203,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Metadata"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "$$File"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FileDocument"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ParticipantInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSignIntent"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FileDocument"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSign"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ErrorInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSignResult"
    ]
  ]
});

const DocumentSignIntent = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1364,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Metadata"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "$$File"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FileDocument"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ParticipantInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DocumentSign = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1771,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FileDocument"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DocumentSignResult = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1939,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ErrorInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Metadata = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1396,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const FileDocument = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1490,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "$$File"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ParticipantInfo = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1617,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignIntent.Metadata";
}

function make(nameOpt, valueOpt, param) {
  const name = nameOpt !== undefined ? nameOpt : "";
  const value = valueOpt !== undefined ? valueOpt : "";
  return {
    name: name,
    value: value
  };
}

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "value",
    "value"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge(t1, t2) {
  return {
    name: Curry._2(merge_name, t1.name, t2.name),
    value: Curry._2(merge_value, t1.value, t2.value)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "value",
      "value"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.name, param.value);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(name, value) {
  return {
    name: name,
    value: value
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.Metadata", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.name, param.value);
  };
}

function constructor$1(name, value) {
  return {
    name: name,
    value: value
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.Metadata", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Metadata, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

const $$File = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1522,
  18
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$1(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument.File";
}

function make$1(mimeOpt, dataOpt, param) {
  const mime = mimeOpt !== undefined ? mimeOpt : "";
  const data = dataOpt !== undefined ? dataOpt : Stdlib__Bytes.of_string("");
  return {
    mime: mime,
    data: data
  };
}

const merge_mime = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "mime",
    "mime"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "data",
    "data"
  ],
  Ocaml_protoc_plugin__Spec.bytes,
  Stdlib__Bytes.of_string("")
]));

function merge$1(t1, t2) {
  return {
    mime: Curry._2(merge_mime, t1.mime, t2.mime),
    data: Curry._2(merge_data, t1.data, t2.data)
  };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "mime",
      "mime"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "data",
      "data"
    ],
    Ocaml_protoc_plugin__Spec.bytes,
    Stdlib__Bytes.of_string("")
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._3(serialize$1, writer, param.mime, param.data);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(mime, data) {
  return {
    mime: mime,
    data: data
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument.File", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.mime, param.data);
  };
}

function constructor$3(mime, data) {
  return {
    mime: mime,
    data: data
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument.File", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, $$File, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument";
}

function make$2(file, param) {
  return {
    file: file
  };
}

const merge_file = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "file",
    "file"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$File.name,
    make: $$File.make,
    from_proto: $$File.from_proto,
    from_proto_exn: $$File.from_proto_exn,
    to_proto: $$File.to_proto,
    to_proto$p: $$File.to_proto$p,
    merge: $$File.merge,
    to_json: $$File.to_json,
    from_json_exn: $$File.from_json_exn,
    from_json: $$File.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    file: Curry._2(merge_file, t1.file, t2.file)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "file",
      "file"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$File.name,
      make: $$File.make,
      from_proto: $$File.from_proto,
      from_proto_exn: $$File.from_proto_exn,
      to_proto: $$File.to_proto,
      to_proto$p: $$File.to_proto$p,
      merge: $$File.merge,
      to_json: $$File.to_json,
      from_json_exn: $$File.from_json_exn,
      from_json: $$File.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.file);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(file) {
  return {
    file: file
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.file);
  };
}

function constructor$5(file) {
  return {
    file: file
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.FileDocument", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "$$File"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, FileDocument, {
  $$File: $$File,
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignIntent.ParticipantInfo";
}

function make$3(signer_type, idOpt, tinOpt, nameOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const tin = tinOpt !== undefined ? tinOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  return {
    signer_type: signer_type,
    id: id,
    tin: tin,
    name: name
  };
}

const merge_signer_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "signer_type",
    "signerType"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType)
]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$3(t1, t2) {
  return {
    signer_type: Curry._2(merge_signer_type, t1.signer_type, t2.signer_type),
    id: Curry._2(merge_id, t1.id, t2.id),
    tin: Curry._2(merge_tin, t1.tin, t2.tin),
    name: Curry._2(merge_name$1, t1.name, t2.name)
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "signer_type",
      "signerType"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_signer_entity_type.Buhta.$$Document.V1.SignerEntityType)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._5(serialize$3, writer, param.signer_type, param.id, param.tin, param.name);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(signer_type, id, tin, name) {
  return {
    signer_type: signer_type,
    id: id,
    tin: tin,
    name: name
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.ParticipantInfo", spec$3(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.signer_type, param.id, param.tin, param.name);
  };
}

function constructor$7(signer_type, id, tin, name) {
  return {
    signer_type: signer_type,
    id: id,
    tin: tin,
    name: name
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent.ParticipantInfo", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ParticipantInfo, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignIntent";
}

function make$4(idOpt, nameOpt, register_numOpt, sign_methodOpt, participant, metadataOpt, sign_documentOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  const register_num = register_numOpt !== undefined ? register_numOpt : 0;
  const sign_method = sign_methodOpt !== undefined ? sign_methodOpt : Curry._1(Buhta_documentapis__Buhta_document_v1_sign_method.Buhta.$$Document.V1.SignMethod.from_int_exn, 0);
  const metadata = metadataOpt !== undefined ? metadataOpt : /* [] */ 0;
  const sign_document = sign_documentOpt !== undefined ? sign_documentOpt : "not_set";
  return {
    id: id,
    name: name,
    register_num: register_num,
    sign_method: sign_method,
    participant: participant,
    metadata: metadata,
    sign_document: sign_document
  };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_name$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_register_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "register_num",
    "registerNum"
  ],
  Ocaml_protoc_plugin__Spec.int64_int,
  0
]));

const merge_sign_method = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "sign_method",
    "signMethod"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_sign_method.Buhta.$$Document.V1.SignMethod),
  Curry._1(Buhta_documentapis__Buhta_document_v1_sign_method.Buhta.$$Document.V1.SignMethod.from_int_exn, 0)
]));

const merge_participant = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    5,
    "participant",
    "participant"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: ParticipantInfo.name,
    make: ParticipantInfo.make,
    from_proto: ParticipantInfo.from_proto,
    from_proto_exn: ParticipantInfo.from_proto_exn,
    to_proto: ParticipantInfo.to_proto,
    to_proto$p: ParticipantInfo.to_proto$p,
    merge: ParticipantInfo.merge,
    to_json: ParticipantInfo.to_json,
    from_json_exn: ParticipantInfo.from_json_exn,
    from_json: ParticipantInfo.from_json
  })
]));

const merge_metadata = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    6,
    "metadata",
    "metadata"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Metadata.name,
    make: Metadata.make,
    from_proto: Metadata.from_proto,
    from_proto_exn: Metadata.from_proto_exn,
    to_proto: Metadata.to_proto,
    to_proto$p: Metadata.to_proto$p,
    merge: Metadata.merge,
    to_json: Metadata.to_json,
    from_json_exn: Metadata.from_json_exn,
    from_json: Metadata.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

const merge_oneof_sign_document__Xml_document = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_oneof_sign_document__File_document = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: FileDocument.name,
    make: FileDocument.make,
    from_proto: FileDocument.from_proto,
    from_proto_exn: FileDocument.from_proto_exn,
    to_proto: FileDocument.to_proto,
    to_proto$p: FileDocument.to_proto$p,
    merge: FileDocument.merge,
    to_json: FileDocument.to_json,
    from_json_exn: FileDocument.from_json_exn,
    from_json: FileDocument.from_json
  })
]));

function merge$4(t1, t2) {
  const match = t1.sign_document;
  const match$1 = t2.sign_document;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Xml_document") {
      if (typeof match$1 === "string" || match$1.NAME !== "Xml_document") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Xml_document",
          VAL: Curry._2(merge_oneof_sign_document__Xml_document, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "File_document" && !(typeof match$1 === "string" || match$1.NAME !== "File_document")) {
      tmp = {
        NAME: "File_document",
        VAL: Curry._2(merge_oneof_sign_document__File_document, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
    id: Curry._2(merge_id$1, t1.id, t2.id),
    name: Curry._2(merge_name$2, t1.name, t2.name),
    register_num: Curry._2(merge_register_num, t1.register_num, t2.register_num),
    sign_method: Curry._2(merge_sign_method, t1.sign_method, t2.sign_method),
    participant: Curry._2(merge_participant, t1.participant, t2.participant),
    metadata: Curry._2(merge_metadata, t1.metadata, t2.metadata),
    sign_document: tmp
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "register_num",
      "registerNum"
    ],
    Ocaml_protoc_plugin__Spec.int64_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "sign_method",
      "signMethod"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_documentapis__Buhta_document_v1_sign_method.Buhta.$$Document.V1.SignMethod),
    Curry._1(Buhta_documentapis__Buhta_document_v1_sign_method.Buhta.$$Document.V1.SignMethod.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      5,
      "participant",
      "participant"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: ParticipantInfo.name,
      make: ParticipantInfo.make,
      from_proto: ParticipantInfo.from_proto,
      from_proto_exn: ParticipantInfo.from_proto_exn,
      to_proto: ParticipantInfo.to_proto,
      to_proto$p: ParticipantInfo.to_proto$p,
      merge: ParticipantInfo.merge,
      to_json: ParticipantInfo.to_json,
      from_json_exn: ParticipantInfo.from_json_exn,
      from_json: ParticipantInfo.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      6,
      "metadata",
      "metadata"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Metadata.name,
      make: Metadata.make,
      from_proto: Metadata.from_proto,
      from_proto_exn: Metadata.from_proto_exn,
      to_proto: Metadata.to_proto,
      to_proto$p: Metadata.to_proto$p,
      merge: Metadata.merge,
      to_json: Metadata.to_json,
      from_json_exn: Metadata.from_json_exn,
      from_json: Metadata.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
    {
      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
        [
          8,
          "xml_document",
          "xmlDocument"
        ],
        Ocaml_protoc_plugin__Spec.string,
        [
          (function (v) {
            return {
              NAME: "Xml_document",
              VAL: v
            };
          }),
          (function (param) {
            if (typeof param === "string") {
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            }
            if (param.NAME === "Xml_document") {
              return param.VAL;
            }
            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                  MEL_EXN_ID: Stdlib.Invalid_argument,
                  _1: "Cannot destruct given oneof"
                });
          })
        ]
      ]),
      tl: {
        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
          [
            9,
            "file_document",
            "fileDocument"
          ],
          Ocaml_protoc_plugin__Spec.message({
            name: FileDocument.name,
            make: FileDocument.make,
            from_proto: FileDocument.from_proto,
            from_proto_exn: FileDocument.from_proto_exn,
            to_proto: FileDocument.to_proto,
            to_proto$p: FileDocument.to_proto$p,
            merge: FileDocument.merge,
            to_json: FileDocument.to_json,
            from_json_exn: FileDocument.from_json_exn,
            from_json: FileDocument.from_json
          }),
          [
            (function (v) {
              return {
                NAME: "File_document",
                VAL: v
              };
            }),
            (function (param) {
              if (typeof param === "string") {
                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                      MEL_EXN_ID: Stdlib.Invalid_argument,
                      _1: "Cannot destruct given oneof"
                    });
              }
              if (param.NAME === "File_document") {
                return param.VAL;
              }
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            })
          ]
        ]),
        tl: /* [] */ 0
      }
    },
    (function (param) {
      if (typeof param === "string") {
        return Stdlib.failwith("Impossible case");
      } else if (param.NAME === "File_document") {
        return 1;
      } else {
        return 0;
      }
    })
  ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._8(serialize$4, writer, param.id, param.name, param.register_num, param.sign_method, param.participant, param.metadata, param.sign_document);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(id, name, register_num, sign_method, participant, metadata, sign_document) {
  return {
    id: id,
    name: name,
    register_num: register_num,
    sign_method: sign_method,
    participant: participant,
    metadata: metadata,
    sign_document: sign_document
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent", spec$4(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.id, param.name, param.register_num, param.sign_method, param.participant, param.metadata, param.sign_document);
  };
}

function constructor$9(id, name, register_num, sign_method, participant, metadata, sign_document) {
  return {
    id: id,
    name: name,
    register_num: register_num,
    sign_method: sign_method,
    participant: participant,
    metadata: metadata,
    sign_document: sign_document
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignIntent", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Metadata"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "$$File"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FileDocument"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ParticipantInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DocumentSignIntent, {
  Metadata: Metadata,
  FileDocument: FileDocument,
  ParticipantInfo: ParticipantInfo,
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

const FileDocument$1 = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1803,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$5(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSign.FileDocument";
}

function make$5(dataOpt, attachedOpt, param) {
  const data = dataOpt !== undefined ? dataOpt : Stdlib__Bytes.of_string("");
  const attached = attachedOpt !== undefined ? attachedOpt : false;
  return {
    data: data,
    attached: attached
  };
}

const merge_data$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "data",
    "data"
  ],
  Ocaml_protoc_plugin__Spec.bytes,
  Stdlib__Bytes.of_string("")
]));

const merge_attached = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "attached",
    "attached"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge$5(t1, t2) {
  return {
    data: Curry._2(merge_data$1, t1.data, t2.data),
    attached: Curry._2(merge_attached, t1.attached, t2.attached)
  };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "data",
      "data"
    ],
    Ocaml_protoc_plugin__Spec.bytes,
    Stdlib__Bytes.of_string("")
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "attached",
      "attached"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._3(serialize$5, writer, param.data, param.attached);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(data, attached) {
  return {
    data: data,
    attached: attached
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSign.FileDocument", spec$5(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.data, param.attached);
  };
}

function constructor$11(data, attached) {
  return {
    data: data,
    attached: attached
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSign.FileDocument", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, FileDocument$1, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSign";
}

function make$6(idOpt, participant_id, sign_documentOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const sign_document = sign_documentOpt !== undefined ? sign_documentOpt : "not_set";
  return {
    id: id,
    participant_id: participant_id,
    sign_document: sign_document
  };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_participant_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "participant_id",
    "participantId"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_oneof_sign_document__Xml_document$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_oneof_sign_document__File_document$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: FileDocument$1.name,
    make: FileDocument$1.make,
    from_proto: FileDocument$1.from_proto,
    from_proto_exn: FileDocument$1.from_proto_exn,
    to_proto: FileDocument$1.to_proto,
    to_proto$p: FileDocument$1.to_proto$p,
    merge: FileDocument$1.merge,
    to_json: FileDocument$1.to_json,
    from_json_exn: FileDocument$1.from_json_exn,
    from_json: FileDocument$1.from_json
  })
]));

function merge$6(t1, t2) {
  const match = t1.sign_document;
  const match$1 = t2.sign_document;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Xml_document") {
      if (typeof match$1 === "string" || match$1.NAME !== "Xml_document") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Xml_document",
          VAL: Curry._2(merge_oneof_sign_document__Xml_document$1, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "File_document" && !(typeof match$1 === "string" || match$1.NAME !== "File_document")) {
      tmp = {
        NAME: "File_document",
        VAL: Curry._2(merge_oneof_sign_document__File_document$1, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
    id: Curry._2(merge_id$2, t1.id, t2.id),
    participant_id: Curry._2(merge_participant_id, t1.participant_id, t2.participant_id),
    sign_document: tmp
  };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "participant_id",
      "participantId"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
    {
      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
        [
          5,
          "xml_document",
          "xmlDocument"
        ],
        Ocaml_protoc_plugin__Spec.string,
        [
          (function (v) {
            return {
              NAME: "Xml_document",
              VAL: v
            };
          }),
          (function (param) {
            if (typeof param === "string") {
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            }
            if (param.NAME === "Xml_document") {
              return param.VAL;
            }
            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                  MEL_EXN_ID: Stdlib.Invalid_argument,
                  _1: "Cannot destruct given oneof"
                });
          })
        ]
      ]),
      tl: {
        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
          [
            6,
            "file_document",
            "fileDocument"
          ],
          Ocaml_protoc_plugin__Spec.message({
            name: FileDocument$1.name,
            make: FileDocument$1.make,
            from_proto: FileDocument$1.from_proto,
            from_proto_exn: FileDocument$1.from_proto_exn,
            to_proto: FileDocument$1.to_proto,
            to_proto$p: FileDocument$1.to_proto$p,
            merge: FileDocument$1.merge,
            to_json: FileDocument$1.to_json,
            from_json_exn: FileDocument$1.from_json_exn,
            from_json: FileDocument$1.from_json
          }),
          [
            (function (v) {
              return {
                NAME: "File_document",
                VAL: v
              };
            }),
            (function (param) {
              if (typeof param === "string") {
                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                      MEL_EXN_ID: Stdlib.Invalid_argument,
                      _1: "Cannot destruct given oneof"
                    });
              }
              if (param.NAME === "File_document") {
                return param.VAL;
              }
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            })
          ]
        ]),
        tl: /* [] */ 0
      }
    },
    (function (param) {
      if (typeof param === "string") {
        return Stdlib.failwith("Impossible case");
      } else if (param.NAME === "File_document") {
        return 1;
      } else {
        return 0;
      }
    })
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._4(serialize$6, writer, param.id, param.participant_id, param.sign_document);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(id, participant_id, sign_document) {
  return {
    id: id,
    participant_id: participant_id,
    sign_document: sign_document
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSign", spec$6(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.id, param.participant_id, param.sign_document);
  };
}

function constructor$13(id, participant_id, sign_document) {
  return {
    id: id,
    participant_id: participant_id,
    sign_document: sign_document
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSign", spec$6(undefined), constructor$13);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FileDocument"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DocumentSign, {
  FileDocument: FileDocument$1,
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

const ErrorInfo = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.ml",
  1971,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$7(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignResult.ErrorInfo";
}

function make$7(codeOpt, messageOpt, param) {
  const code = codeOpt !== undefined ? codeOpt : 0;
  const message = messageOpt !== undefined ? messageOpt : "";
  return {
    code: code,
    message: message
  };
}

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "code",
    "code"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "message",
    "message"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$7(t1, t2) {
  return {
    code: Curry._2(merge_code, t1.code, t2.code),
    message: Curry._2(merge_message, t1.message, t2.message)
  };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "code",
      "code"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "message",
      "message"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.code, param.message);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(code, message) {
  return {
    code: code,
    message: message
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignResult.ErrorInfo", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.code, param.message);
  };
}

function constructor$15(code, message) {
  return {
    code: code,
    message: message
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignResult.ErrorInfo", spec$7(undefined), constructor$15);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ErrorInfo, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

function name$8(param) {
  return ".buhta.edo.sign.v1alpha1.DocumentSignResult";
}

function make$8(intent, successOpt, error, param) {
  const success = successOpt !== undefined ? successOpt : false;
  return {
    intent: intent,
    success: success,
    error: error
  };
}

const merge_intent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "intent",
    "intent"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: DocumentSignIntent.name,
    make: DocumentSignIntent.make,
    from_proto: DocumentSignIntent.from_proto,
    from_proto_exn: DocumentSignIntent.from_proto_exn,
    to_proto: DocumentSignIntent.to_proto,
    to_proto$p: DocumentSignIntent.to_proto$p,
    merge: DocumentSignIntent.merge,
    to_json: DocumentSignIntent.to_json,
    from_json_exn: DocumentSignIntent.from_json_exn,
    from_json: DocumentSignIntent.from_json
  })
]));

const merge_success = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "success",
    "success"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_error = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "error",
    "error"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: ErrorInfo.name,
    make: ErrorInfo.make,
    from_proto: ErrorInfo.from_proto,
    from_proto_exn: ErrorInfo.from_proto_exn,
    to_proto: ErrorInfo.to_proto,
    to_proto$p: ErrorInfo.to_proto$p,
    merge: ErrorInfo.merge,
    to_json: ErrorInfo.to_json,
    from_json_exn: ErrorInfo.from_json_exn,
    from_json: ErrorInfo.from_json
  })
]));

function merge$8(t1, t2) {
  return {
    intent: Curry._2(merge_intent, t1.intent, t2.intent),
    success: Curry._2(merge_success, t1.success, t2.success),
    error: Curry._2(merge_error, t1.error, t2.error)
  };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "intent",
      "intent"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: DocumentSignIntent.name,
      make: DocumentSignIntent.make,
      from_proto: DocumentSignIntent.from_proto,
      from_proto_exn: DocumentSignIntent.from_proto_exn,
      to_proto: DocumentSignIntent.to_proto,
      to_proto$p: DocumentSignIntent.to_proto$p,
      merge: DocumentSignIntent.merge,
      to_json: DocumentSignIntent.to_json,
      from_json_exn: DocumentSignIntent.from_json_exn,
      from_json: DocumentSignIntent.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "success",
      "success"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "error",
      "error"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: ErrorInfo.name,
      make: ErrorInfo.make,
      from_proto: ErrorInfo.from_proto,
      from_proto_exn: ErrorInfo.from_proto_exn,
      to_proto: ErrorInfo.to_proto,
      to_proto$p: ErrorInfo.to_proto$p,
      merge: ErrorInfo.merge,
      to_json: ErrorInfo.to_json,
      from_json_exn: ErrorInfo.from_json_exn,
      from_json: ErrorInfo.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._4(serialize$8, writer, param.intent, param.success, param.error);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(intent, success, error) {
  return {
    intent: intent,
    success: success,
    error: error
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.DocumentSignResult", spec$8(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.intent, param.success, param.error);
  };
}

function constructor$17(intent, success, error) {
  return {
    intent: intent,
    success: success,
    error: error
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.DocumentSignResult", spec$8(undefined), constructor$17);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ErrorInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DocumentSignResult, {
  ErrorInfo: ErrorInfo,
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Metadata"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "$$File"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FileDocument"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ParticipantInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSignIntent"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FileDocument"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSign"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ErrorInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentSignResult"
    ]
  ]
}, V1alpha1, {
  DocumentSignIntent: DocumentSignIntent,
  DocumentSign: DocumentSign,
  DocumentSignResult: DocumentSignResult
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Metadata"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "$$File"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FileDocument"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ParticipantInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSignIntent"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FileDocument"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSign"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ErrorInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DocumentSignResult"
          ]
        ]
      },
      "V1alpha1"
    ]]
}, Sign, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Metadata"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "$$File"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "FileDocument"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ParticipantInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSignIntent"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "FileDocument"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSign"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ErrorInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DocumentSignResult"
                ]
              ]
            },
            "V1alpha1"
          ]]
      },
      "Sign"
    ]]
}, Edo, {
  Sign: Sign
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Metadata"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    {
                                      TAG: /* Module */ 0,
                                      _0: [
                                        [
                                          /* Function */ 0,
                                          "make"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_proto"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_proto"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_json"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_json"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "name"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "merge"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "to_proto$p"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_proto_exn"
                                        ],
                                        [
                                          /* Function */ 0,
                                          "from_json_exn"
                                        ]
                                      ]
                                    },
                                    "$$File"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "FileDocument"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ParticipantInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSignIntent"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "FileDocument"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSign"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ErrorInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DocumentSignResult"
                      ]
                    ]
                  },
                  "V1alpha1"
                ]]
            },
            "Sign"
          ]]
      },
      "Edo"
    ]]
}, Buhta, {
  Edo: Edo
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
